module.exports = __webpack_public_path__ + "img/athlete-soccer-background-left.6c3fa33f.svg";